import { TIMESTAMP, db } from "./firebase"

export default {
  devicesStatusRef(projectId) {
    return db.ref("devicesStatus").child(projectId)
  },

  onDevicesStatusChanged(projectId, callback, errorCallback) {
    this.devicesStatusRef(projectId).on(
      "value",
      pingValuesSnapshot => {
        callback(pingValuesSnapshot.val() || {})
      },
      errorCallback
    )
  },
  offDevicesStatusChanged(projectId) {
    this.devicesStatusRef(projectId).off()
  },

  onlineTracking(projectId, deviceId) {
    const connectedClientTime = Date.now()
    this.devicesStatusRef(projectId)
      .child(deviceId)
      .set({ connectedClientTime, connected: TIMESTAMP })
      // eslint-disable-next-line no-console
      .catch(e => console.error("Error writing timestamp on connect", e))
    this.devicesStatusRef(projectId)
      .child(deviceId)
      .child("disconnected")
      .onDisconnect()
      .set(TIMESTAMP)
      // eslint-disable-next-line no-console
      .catch(e => console.error("Error writing timestamp on disconnect", e))
  }
}
